import DataForm from "./DataForm";

export default class EditCtrl {

  constructor(item, saveHandler){
    this.saveHandler = saveHandler;
    this.load(item);
  }

  save(){
    this.saveHandler(this.item.id, this.form.getUpdateDto()).then(item => this.load(item));
  }

  reset(){
    this.form.reset();
  }

  load(item){
    console.log(item);
    this.item = item;
    this.form = new DataForm(this.item, !this.item.id);
  }

}


// WEBPACK FOOTER //
// ./src/Editor/EditCtrl.js